import { BottomSheetOptions } from 'types/bottomsheet';
import CommonContent from 'components/bottomsheet/CommonContent';
import NeedCoinContent from './shop/NeedCoin';
import NewAppNotice from './notice/NewAppNotice';
import SearchBonusPromo from './shop/SearchBonusPromo';
import AgencyInput from './prime/AgencyInput';
import SmartStoreOrder from './shop/SmartStoreOrder';
import PrimeSwipeCall from './prime/PrimeSwipeCall';
import PrimeSwipeCallEnd from './prime/PrimeSwipeCallEnd';
import PrimeGemCostConfirm from './prime/PrimeGemCostConfirm';
import MyProfile from './profile/MyProfile';
import UserProfile from './profile/UserProfile';
import ProfileEdit from './profile/edit/ProfileEdit';
import BlockReportMenu from './profile/block/BlockReportMenu';
import UploadPhoto from './profile/edit/UploadPhoto';
import NicknameChange from './nickname/NicknameChange';
import BJCallCostConfirm from './notice/BJCallCostConfirm';
import PrimeBJRestriction from './prime/PrimeBJRestriction';

const BOTTOM_SHEETS: Record<string, { content: React.ComponentType; options?: BottomSheetOptions }> = {
  Common: { content: CommonContent },
  NewAppNotice: { content: NewAppNotice, options: { maxHeight: '90%', scrollable: false } },
  NeedCoin: { content: NeedCoinContent, options: { showMyCoin: true } },
  SearchBonusPromo: { content: SearchBonusPromo, options: { background: 'transparent', maxHeight: '100%', hideBar: true, showMyCoin: true } },
  AgencyInput: { content: AgencyInput, options: { maxHeight: '50%', scrollable: false } },
  SmartStoreOrder: { content: SmartStoreOrder },
  PrimeSwipeCall: { content: PrimeSwipeCall, options: { scrollable: false } },
  PrimeSwipeCallEnd: { content: PrimeSwipeCallEnd, options: { scrollable: false } },
  PrimeGemCostConfirm: { content: PrimeGemCostConfirm },
  MyProfile: {
    content: MyProfile,
    options: {
      scrollable: false,
      showScrollBar: true,
      containerStyle: {
        borderTopLeftRadius: '32px',
        borderTopRightRadius: '32px',
      },
    },
  },
  UserProfile: {
    content: UserProfile,
    options: {
      scrollable: false,
      showScrollBar: true,
      containerStyle: {
        borderTopLeftRadius: '32px',
        borderTopRightRadius: '32px',
      },
    },
  },
  BlockReportMenu: {
    content: BlockReportMenu,
    options: {
      scrollable: false,
      containerStyle: {
        minHeight: 'auto',
        borderTopLeftRadius: '32px',
        borderTopRightRadius: '32px',
      },
    },
  },
  ProfileEdit: {
    content: ProfileEdit,
    options: {
      fullScreen: true,
      background: '#10101C',
      draggable: false,
      scrollable: false,
    },
  },
  UploadPhoto: {
    content: UploadPhoto,
    options: {
      scrollable: false,
      showScrollBar: true,
      containerStyle: {
        borderTopLeftRadius: '32px',
        borderTopRightRadius: '32px',
      },
    },
  },
  NicknameChange: {
    content: NicknameChange,
  },
  BJCallCostConfirm: { content: BJCallCostConfirm },
  PrimeBJRestriction: { content: PrimeBJRestriction, options: { scrollable: false } },
};

export default BOTTOM_SHEETS;
